import React from 'react';

import { EType, IMedia } from '../../types';
import { CarouselPhoto } from '../CarouselPhoto';
import { CarouselVideo } from '../CarouselVideo';
import { CarouselCianLayout } from '../CarouselCianLayout';

interface ICarouselElementProps {
  media: IMedia;
  isActive: boolean;
}

const CarouselElementComponent: React.FC<ICarouselElementProps> = ({ media, isActive }) => {
  switch (media.type) {
    case EType.Layout:
      return <CarouselPhoto src={media.url} objectFit="contain" />;
    case EType.Photo:
      return <CarouselPhoto src={media.url} />;
    case EType.CianLayout:
      return <CarouselCianLayout src={media.url} />;

    case EType.Video:
      return <CarouselVideo src={media.url} isActive={isActive} />;
  }

  return null;
};

export const CarouselElement = React.memo(CarouselElementComponent);
